import { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Typography } from "@mui/material";
import { getCookie } from "utils/setCookie";
import { uploadMedia } from "entities/course/service";

type CustomEditorProps = {
  title: string;
  initValue: any;
  onChange: (field: string, value: any) => void;
  field: string;
};

function CustomEditor({
  onChange,
  initValue,
  field,
  title,
}: CustomEditorProps) {
  const editorRef = useRef(null);

  return (
    <div id="your-modal-toolbar-container">
      <Typography variant="body2">{title}</Typography>
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        licenseKey="uk1j6kk7a2yxyjpikdvkcwi5f8iug257swqr9nyyhrma0451"
        // initialValue={initValue}
        value={initValue}
        onEditorChange={(value) => onChange(field, value)}
        onInit={(evt, editor) => (editorRef.current = editor)}
        init={{
          fixed_toolbar_container: "#your-modal-toolbar-container",
          selector: "textarea#open-source-plugins",
          plugins:
            "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap emoticons accordion",
          editimage_cors_hosts: ["picsum.photos"],
          menubar: "file edit view insert format tools table help",
          toolbar:
            "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl myImageUpload",
          autosave_ask_before_unload: true,
          autosave_interval: "30s",
          autosave_prefix: "{path}{query}-{id}-",
          autosave_restore_when_empty: false,
          autosave_retention: "2m",
          image_advtab: true,
          link_list: [
            { title: "My page 1", value: "https://www.tiny.cloud" },
            { title: "My page 2", value: "http://www.moxiecode.com" },
          ],
          image_list: [
            { title: "My page 1", value: "https://www.tiny.cloud" },
            { title: "My page 2", value: "http://www.moxiecode.com" },
          ],
          image_class_list: [
            { title: "None", value: "" },
            { title: "Some class", value: "class-name" },
          ],
          importcss_append: true,
          automatic_uploads: true,
          paste_data_images: false,
          file_picker_callback: (callback, value, meta) => {
            /* Provide file and text for the link dialog */
            if (meta.filetype === "file") {
              callback("https://www.google.com/logos/google.jpg", {
                text: "My text",
              });
            }

            /* Provide image and alt text for the image dialog */
            if (meta.filetype === "image") {
              callback("https://www.google.com/logos/google.jpg", {
                alt: "My alt text",
              });
            }

            /* Provide alternative source and posted for the media dialog */
            if (meta.filetype === "media") {
              callback("movie.mp4", {
                source2: "alt.ogg",
                poster: "https://www.google.com/logos/google.jpg",
              });
            }
          },
          height: 600,
          image_caption: true,
          // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
          noneditable_class: "mceNonEditable",
          toolbar_mode: "sliding",
          contextmenu: "link image table",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
          setup: function (editor) {
            editor.ui.registry.addButton("myImageUpload", {
              icon: "image",
              tooltip: "Insert Image",
              onAction: function () {
                const input = document.createElement("input");
                input.type = "file";
                input.accept = "image/*";

                input.onchange = async function () {
                  const file = input.files[0];

                  if (!file) return;
                  // ✅ Show loading notification
                  const notification = editor.notificationManager.open({
                    text: "Uploading image...",
                    type: "info",
                    timeout: 0, // don't auto-close
                    progressBar: true,
                  });
                  const headers = { "X-Authorization": getCookie("session") };

                  const result = await uploadMedia(file, headers);

                  // ✅ Close loading and insert image
                  notification.close();

                  if (result && result[0] && result[0].src) {
                    editor.insertContent(`<img src="${result[0].src}" />`);
                  } else {
                    notification.close();
                  }
                };

                input.click();
              },
            });
            editor.on("init", () => {
              editor.execCommand("mceRepaint");
            });
          },
        }}
      />
    </div>
  );
}

export default CustomEditor;
